import { APIClient } from "./api_helper";

const api = new APIClient();

export const fetchPortalLeads = async ({
    page = 1,
    pageLimit = 25,
    order = "ASC",
    orderBy = "",
    search = "",
    cvid = null,
} = {}) => {

    const response = await api.create("/userportal", {
        _operation: "FetchRecords",
        module: "Leads",
        mode: "all",

        ...(cvid ? { cvid } : {}),

        pageLimit,
        page,
        order,
        orderBy,
        search,
    });

    console.log("Leads API Response:", response);

    if (!response?.success) {
        throw new Error(
            response?.error?.message ||
            response?.result?.message ||
            "Failed to fetch leads"
        );
    }

    const result = response.result || {};

    return {
        data: Array.isArray(result.data)
            ? result.data
            : [],

        count: Number(result.count || 0),

        page: Number(result.page || page),

        pageLimit: Number(
            result.pageLimit || pageLimit
        ),

        orderBy: result.orderBy || orderBy,

        order: result.order || order,

        customFilter: result.customFilter || {},

        cvid: result.cvid || cvid,
    };
};


export const createPortalLead = async (lead) => {

    const nameParts = (lead.name || "").trim().split(/\s+/);

    const firstname = nameParts.shift() || "";
    const lastname = nameParts.join(" ") || firstname;

    const response = await api.create("/userportal", {

        _operation: "CreateRecord",

        module: "Leads",

        data: {
            firstname: firstname,
            lastname: lastname,
            company: lead.company || "",
            email: lead.email || "",
            phone: lead.phone || "",
            lane: lead.location || "",
            cf_907: lead.course || "",
            leadstatus: lead.leadstatus || "",
            assigned_user_id: lead.assigned_user_id || "",
        },
    });

    console.log(
        "CREATE LEAD API RESPONSE:",
        response
    );

    if (!response?.success) {
        throw new Error(
            response?.error?.message ||
            response?.result?.message ||
            "Failed to create lead"
        );
    }

    return response.result;
};
// export const fetchLeadFilters = async () => {

//     const response = await api.create("/userportal", {
//         _operation: "FetchCustomViews",
//         module: "Leads",
//     });

//     console.log(
//         "Lead Custom Views Response:",
//         response
//     );

//     if (!response?.success) {
//         throw new Error(
//             response?.error?.message ||
//             response?.result?.message ||
//             "Failed to fetch lead filters"
//         );
//     }

//     return {
//         filters: Array.isArray(
//             response?.result?.filters
//         )
//             ? response.result.filters
//             : [],
//     };
// };

export const fetchLeadFilters = async () => {

    const response = await api.create("/userportal", {
        _operation: "FetchRecords",
        module: "Leads",
        fetchLeadStatuses: true,
    });

    console.log(
        "CRM Lead Status Response:",
        response
    );

    if (!response?.success) {
        throw new Error(
            response?.error?.message ||
            response?.result?.message ||
            "Failed to fetch CRM lead statuses"
        );
    }

    return {
        leadStatuses: Array.isArray(
            response?.result?.leadStatuses
        )
            ? response.result.leadStatuses
            : [],
    };
};